import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
    const { isAuthenticated, isLoading } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (!isLoading && !isAuthenticated) {
            navigate("/login", { replace: true });
        }
    }, [isAuthenticated, isLoading, navigate]);

    if (isLoading) {
        return (
            <div className="auth-loading">
                <div className="auth-spinner" />
            </div>
        );
    }

    if (!isAuthenticated) return null;

    return <>{children}</>;
}

export function AdminRoute({ children }: { children: React.ReactNode }) {
    const { user, isAuthenticated, isLoading } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (!isLoading && !isAuthenticated) {
            navigate("/login", { replace: true });
        } else if (!isLoading && isAuthenticated && user?.role !== "admin") {
            navigate("/dashboard", { replace: true });
        }
    }, [isAuthenticated, isLoading, user, navigate]);

    if (isLoading) {
        return (
            <div className="auth-loading">
                <div className="auth-spinner" />
            </div>
        );
    }

    if (!isAuthenticated || user?.role !== "admin") return null;

    return <>{children}</>;
}

export function PublicOnlyRoute({ children }: { children: React.ReactNode }) {
    const { isAuthenticated, isLoading } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (!isLoading && isAuthenticated) {
            navigate("/dashboard", { replace: true });
        }
    }, [isAuthenticated, isLoading, navigate]);

    if (isLoading) {
        return (
            <div className="auth-loading">
                <div className="auth-spinner" />
            </div>
        );
    }

    if (isAuthenticated) return null;

    return <>{children}</>;
}
